import React from "react"
import ReactDOM from "react-dom"
import FactsAndFiguresGifContainer from "./facts-and-figures-gif-container-component"

export default class FactsAndFiguresGifContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.language = (document.body && document.body.dataset.language) || "da"
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<FactsAndFiguresGifContainer {...self.modelJson} language={self.language} />, self.elem)
  }
}
